export const NORMAL_WIDTH = 500;
export const CARD_PADDING = 12;
export const MIN_SCALE_WIDTH = 300;
